module.exports = __webpack_public_path__ + "img/電気回路_4_6_4.e7441fe8.png";